import { render, staticRenderFns } from "./page-docs.vue?vue&type=template&id=8f141956&"
import script from "./page-docs.vue?vue&type=script&lang=js&"
export * from "./page-docs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports